// Footer.js
const Footer = () => <footer>Global Footer</footer>;
export default Footer;
